import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  amSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import attachRecommendationDialog from '../dialog.saveRecommendationConfirmDialog/attachRecommendationDialog';
import editRecommendationCommentDialog from '../dialog.editRecommendationCommentDialog';
import editRecommendationDialog from '../dialog.editRecommendationDialog';
import controller from './recommendation.controller';
import directive from './recommendation.directive';
import recommendationComment from '../recommendationComment';
import recommendationDocument from '../recommendationDocument';
import recommendationReport from '../recommendationReport';


export default angular.module('app.components.advisory.auditTrail.recommendation', [
  alerts,
  amDataService,
  amSharedModelService,
  attachRecommendationDialog,
  confirmDialog,
  constants,
  docDataService,
  editRecommendationCommentDialog,
  editRecommendationDialog,
  recommendationComment,
  recommendationDocument,
  recommendationReport,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amRecommendation', directive)
  .controller('RecommendationController', controller)
  .name;

console.log('app.components.advisory.auditTrail.recommendation created');
